// Format time ago (just now, 5m, 2h, etc.)
export const formatTimeAgo = (dateString) => {
  const date = new Date(dateString);
  const now = new Date();
  const diffInSeconds = Math.floor((now - date) / 1000);

  if (diffInSeconds < 60) return "just now";
  if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}m`;
  if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)}h`;
  if (diffInSeconds < 604800) return `${Math.floor(diffInSeconds / 86400)}d`;
  return `${Math.floor(diffInSeconds / 604800)}w`;
};

// Format count (1000 -> 1K, 1000000 -> 1M)
export const formatCount = (count) => {
  if (!count || count === 0) return "0";
  const num = parseInt(count);
  if (num < 1000) return num.toString();
  if (num < 1000000) {
    const thousands = num / 1000;
    return `${thousands.toFixed(1).replace(/\.0$/, "")}K`;
  }
  const millions = num / 1000000;
  return `${millions.toFixed(1).replace(/\.0$/, "")}M`;
};

// Get initials from name (John Doe -> JD)
export const getInitials = (name = "User") => {
  if (!name || typeof name !== "string") return "U";
  const words = name.trim().split(/\s+/);
  if (words.length === 1) return words[0].charAt(0).toUpperCase();
  return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
};